export const setBackEndUlr = (type="backend")=>{
    if(type==="backend")
    {
        if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") 
        {
            return "https://localhost:5001"
        }
        else{
            return window.location.origin 
        }

    }
    else{
        if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") 
            {
                return "http://localhost:3000"
            }
            else{
                return window.location.origin 
            }

    }
}